// src/views/EjecucionesManuales/EjecutarProcesoDeLiquidacion/EjecutarProcesoDeLiquidacion.jsx
import React from "react";
import EjecutarProceso from "../../EstadosFlujos/Procesos/EjecutarProceso";

export default function EjecutarProcesoDeLiquidacion({ onRedirect }) {
  return (
    <EjecutarProceso
      procesoId={1}
      titulo="Ejecutar proceso de Liquidación"
      redirectView="ejecucionLiquidaciones" // ✅ SIN SLASH
      onRedirect={onRedirect}
    />
  );
}
